import React from 'react';
import PropTypes from 'prop-types';
import Card from '@welldev-group/rcl-card';
import GenericInfoCard from '../../../../shared/components/GenericInfoCard';
import InfoCard from '../../../../shared/components/InfoCard';
import AffiliateBriefing from './AffiliateBriefing';

const AffiliateOverview = ({ affiliate, updateAffiliate }) => {
  const {
    bookingsTotal,
    totalIssuedTickets,
    travelersTotal,
    currentWorkspacesSize,
    chargeableChannelCount,
    ndcChannelCount,
    clientName,
    briefing,
    briefingUpdatedAt,
    activeUsers,
  } = affiliate;

  const cardData = [
    {
      key: 'bookings',
      value: Number(bookingsTotal),
      info: I18n.t('components.affiliate_three_sixty.affiliate.overview.bookings'),
    },
    {
      key: 'tickets',
      value: Number(totalIssuedTickets),
      info: I18n.t('components.affiliate_three_sixty.affiliate.overview.issued_tickets'),
    },
  ];

  return (
    <>
      <div className="grid">
        <div className="col-4">
          <Card version="v2">
            {cardData.map(({ key, value, info }) => (
              <InfoCard key={key} value={value} info={info} />
            ))}
          </Card>
        </div>
        <div className="col-4 col-bleed-x">
          <GenericInfoCard
            value={Number(travelersTotal)}
            info={I18n.t(
              'components.affiliate_three_sixty.affiliate.overview.travelers',
            )}
          />
        </div>
        <div className="col-4">
          <GenericInfoCard
            value={currentWorkspacesSize}
            info={I18n.t(
              'components.affiliate_three_sixty.affiliate.overview.workspaces',
            )}
          />
        </div>
        <div className="col-4">
          <GenericInfoCard
            value={activeUsers}
            info={I18n.t(
              'components.affiliate_three_sixty.affiliate.overview.users',
            )}
          />
        </div>
        <div className="col-4 col-bleed-x">
          <GenericInfoCard
            value={chargeableChannelCount}
            info={I18n.t(
              'components.affiliate_three_sixty.affiliate.overview.chargeable_channels',
            )}
          />
        </div>
        <div className="col-4">
          <GenericInfoCard
            value={ndcChannelCount}
            info={I18n.t(
              'components.affiliate_three_sixty.affiliate.overview.ndc_channels',
            )}
          />
        </div>
      </div>

      <AffiliateBriefing
        name={clientName}
        briefing={briefing}
        briefingUpdatedAt={briefingUpdatedAt}
        updateAffiliate={updateAffiliate}
        placeholder={I18n.t(
          'components.affiliate_three_sixty.affiliate.overview.placeholder',
        )}
      />
    </>
  );
};

AffiliateOverview.propTypes = {
  affiliate: PropTypes.shape({
    bookingsTotal: PropTypes.number,
    totalIssuedTickets: PropTypes.number,
    travelersTotal: PropTypes.number,
    currentWorkspacesSize: PropTypes.number,
    chargeableChannelCount: PropTypes.number,
    ndcChannelCount: PropTypes.number,
    clientName: PropTypes.string,
    briefing: PropTypes.string,
    briefingUpdatedAt: PropTypes.string,
    activeUsers: PropTypes.number,
  }).isRequired,
  updateAffiliate: PropTypes.func.isRequired,
};

export default AffiliateOverview;
